import ISvgProps from '../../../SvgLoader/ISvgProps';

const SvgRealEstate = (props: ISvgProps) => (
	<svg width={61} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#Realestate_svg__a)">
			<path
				d="M7.717 36.401 22.91 21.986a1.065 1.065 0 0 1 1.464.004l.007.008 15.03 14.407.008.008.476.421c.231.206.352.49.352.773h.004v21.341c0 .575-.473 1.042-1.055 1.042H8.093a1.049 1.049 0 0 1-1.056-1.042V37.492c0-.322.148-.613.382-.803l.303-.288h-.005Zm15.919-12.22L9.177 37.9l-.034.034v19.974h28.993V38.07l-.12-.109c-.027-.019-.05-.04-.077-.063L23.636 24.185v-.003Z"
				fill={props.primaryColor}
			/>
			<path
				d="M19.553 44.929h8.175c.582 0 1.055.467 1.055 1.042v12.996c0 .575-.473 1.042-1.055 1.042h-8.175a1.049 1.049 0 0 1-1.055-1.042V45.971c0-.575.473-1.042 1.055-1.042Zm7.116 2.087h-6.06v10.91h6.06v-10.91ZM2.637 37.921c-.42.396-1.09.381-1.49-.037a1.03 1.03 0 0 1 .037-1.471l21.73-20.367a1.063 1.063 0 0 1 1.452 0l21.73 20.367c.42.396.439 1.053.038 1.47a1.066 1.066 0 0 1-1.49.038L23.64 18.234 2.637 37.92Z"
				fill={props.primaryColor}
			/>
			<path
				d="M7.386 32.032a1.057 1.057 0 0 1-1.058-1.057V24.92a3.136 3.136 0 0 1 6.272 0v2.16a1.057 1.057 0 1 1-2.115 0v-2.188a1.021 1.021 0 0 0-2.043 0v6.083c0 .584-.472 1.057-1.056 1.057Z"
				fill={props.primaryColor}
			/>
			<path
				d="M30.898 5.096a7.25 7.25 0 0 1 5.107-2.087c1.848 0 3.695.696 5.106 2.087a7.06 7.06 0 0 1 0 10.08 7.25 7.25 0 0 1-5.106 2.087 7.254 7.254 0 0 1-5.107-2.087 7.06 7.06 0 0 1 0-10.08Zm5.107-.694c-1.488 0-2.972.56-4.108 1.68a5.68 5.68 0 0 0 0 8.108 5.833 5.833 0 0 0 4.108 1.68c1.487 0 2.971-.56 4.107-1.68a5.68 5.68 0 0 0 0-8.108 5.833 5.833 0 0 0-4.108-1.68Z"
				fill={props.secondaryColor}
				stroke={props.secondaryColor}
				strokeWidth={0.3}
			/>
			<path
				d="M42.156 12.842 56.906 27.4a.691.691 0 0 1 0 .986l-2.26 2.232a.713.713 0 0 1-1 0L38.933 16.097a.691.691 0 0 1 .177-1.114 5.86 5.86 0 0 0 .498-.35c.17-.132.337-.279.501-.444.19-.187.36-.377.509-.569.154-.2.295-.41.424-.631a.713.713 0 0 1 1.114-.147ZM55.41 27.895 41.767 14.43l-.028.035a7.172 7.172 0 0 1-1.217 1.23L54.145 29.14l1.262-1.245h.003Z"
				fill={props.secondaryColor}
				stroke={props.secondaryColor}
				strokeWidth={0.3}
			/>
			<path
				d="M52.413 28.394a.714.714 0 0 1 1 0 .691.691 0 0 1 0 .986l-2.482 2.448a.713.713 0 0 1-.999 0 .691.691 0 0 1 0-.985l2.481-2.45ZM50.196 26.202a.713.713 0 0 1 .999 0 .691.691 0 0 1 0 .986l-2.428 2.396a.713.713 0 0 1-1 0 .691.691 0 0 1 0-.986l2.429-2.396ZM47.975 24.012a.713.713 0 0 1 .999 0 .691.691 0 0 1 0 .986l-2.32 2.29a.713.713 0 0 1-.999 0 .691.691 0 0 1 0-.987l2.32-2.289ZM36.2 6.274a2.24 2.24 0 0 1 .67 1.6 2.24 2.24 0 0 1-.67 1.6 2.3 2.3 0 0 1-1.62.662 2.3 2.3 0 0 1-1.622-.661 2.24 2.24 0 0 1-.67-1.6c0-.58.222-1.159.67-1.6a2.3 2.3 0 0 1 1.621-.662 2.3 2.3 0 0 1 1.621.661Zm-.74 1.6a.86.86 0 0 0-.259-.614.883.883 0 0 0-.622-.254.883.883 0 0 0-.622.254.86.86 0 0 0 0 1.228.883.883 0 0 0 1.244 0 .86.86 0 0 0 .258-.614Z"
				fill={props.secondaryColor}
				stroke={props.secondaryColor}
				strokeWidth={0.3}
			/>
		</g>
		<defs>
			<clipPath id="Realestate_svg__a">
				<path fill="#fff" transform="translate(.355)" d="M0 0h60v60H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default SvgRealEstate;
